import * as actionTypes from './actions';

const initialState = {
  project: null
};

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROJECT:
      return {
        ...state,
        project: action.project
      };
    default:
      return state;
  }
};

export default projectReducer;
